/* import React from 'react'

import { shuffle } from '../../../utils';

const beads = shuffle(['azul_p.png', 'rojo_p.png', 'amarillo_p.png', 'gris_p.png', 'marron_p.png']);

class Couples extends React.Component {
    state = {
        items: [],
        opened: null,
        flipped: 0,
        remaining: 0,
        time: 0,
        sound: null,
    }

    componentDidMount() {
        // console.log('Couples.componentWillMount:', this.state, this.props)
        const num_items = this.props.items;
        const side = !this.props.showBack ? 'front' : 'back';

        const type = this.props.type ? this.props.type : 'beads';
        let items = [];

        if (type === 'abacus') {
            const series = this.props.series;
            for (let idx = 0; idx < series.length; idx++) {
                items.push({ val: series[idx], side: side, img: 1 });
                items.push({ val: series[idx], side: side, img: 0 });
            }
        } else {
            for (let idx = 0; idx < num_items; idx++) {
                items.push({ val: idx, side: side });
                items.push({ val: idx, side: side });
            }
        }

        const date = new Date();
        this.setState({ items: shuffle(items), remaining: num_items, time: date.getTime() })
    }

    clickHandle = (idx, item) => {
        // console.log('clickHandle:', idx, item);
        if (item.side === 'back') {
            const items = this.state.items;
            const flipped = this.state.flipped;

            if (flipped < 2) {
                items[idx] = { ...item, side: 'front' };
                const prev_idx = this.state.opened;
                const prev_opened = this.state.opened !== null ? this.state.items[prev_idx] : null;
                const eqs = prev_opened ? (prev_opened.val === items[idx].val) : false;

                this.setState({ items, opened: idx, flipped: flipped + 1, sound: './static/sounds/woosh.mp3' });

                if (flipped === 1) {
                    let remaining = this.state.remaining;

                    if (!eqs) {
                        this.setState({ sound: './static/sounds/spin_jump.mp3' })
                        setTimeout(() => {
                            items[idx] = { ...items[idx], side: 'back' };
                            items[prev_idx] = { ...items[prev_idx], side: 'back' };
                            this.setState({ items, opened: null, flipped: 0, sound: null })
                        }, 500);
                    } else {
                        remaining--;
                        this.setState({ sound: './static/sounds/clink.mp3' });
                        setTimeout(() => {
                            if (remaining === 0) {
                                const date = new Date();
                                this.props.onComplete(date.getTime() - this.state.time);
                            } else {
                                this.setState({ items, opened: null, flipped: 0, remaining, sound: null });
                            }
                        }, 800);
                    }

                } else {
                    //only one flipped
                }
            }
        } else {
            //showing front
        }
    }

    UNSAFE_componentWillReceiveProps() {
        // console.log('Couples.componentWillReceiveProps:', this.state, this.props);
        const items = this.state.items;
        const completed = (this.state.remaining === 0);
        if (!completed) for (let idx = 0; idx < items.length; idx++) {
            items[idx] = { ...items[idx], side: 'back' };
        }
    }

    render() {
        // console.log('Couples:', this.props, this.state);
        const props = this.props;
        const items = this.state.items;
        const completed_style = (this.state.remaining === 0) ? 'completed' : '';

        return (
            <div className={`couple-list ${completed_style}`}>
                {this.state.sound ? <audio src={this.state.sound} autoPlay={true} loop={false}></audio> : null}

                {items.map((aI, idx) => {
                    const val = aI.val;
                    let digits = val.toString().split('');

                    const isImg = aI.img != null ? aI.img : 1;
                    let imgs = [];

                    if (props.type === 'abacus') {
                        if (isImg) {
                            digits.forEach(aD =>{
                                imgs.push(`./static/snapshots/a${aD}.png`);
                            });
                        } else imgs.push(val);
                    } else {
                        for (let idx = 0; idx < this.props.beads; idx++) {
                            imgs.push(`./static/beads/${beads[val]}`);
                        }
                    }

                    const back = <img src={`./static/beads/back.jpg`} alt="bead" />;
                    return (<div key={idx} onClick={() => this.clickHandle(idx, aI)}>
                        {aI.side === 'back' ? back : imgs.map((aImg, idy) => {
                            return isImg ? <img className="bead" src={aImg} alt="bead" key={idy} /> : <span key={idy}>{aImg}</span>
                        })}
                    </div>);
                })}
            </div>
        );
    }
}

export default Couples;
 */

import React, { useState, useEffect, useRef } from 'react';
import { shuffle } from '../../../utils';

// Beads globales (no cambian entre renders)
const beads = shuffle(['azul_p.png', 'rojo_p.png', 'amarillo_p.png', 'gris_p.png', 'marron_p.png']);

const Couples = ({ items: numItems, showBack, series, type, onComplete }) => {
    const [state, setState] = useState({
        items: [],
        opened: null,
        flipped: 0,
        remaining: 0,
        time: 0,
        sound: null,
    });

    const prevPropsRef = useRef({ numItems, series, showBack, type });

    useEffect(() => {
        const side = !showBack ? 'front' : 'back';
        let newItems = [];

        if (type === 'abacus') {
            for (let idx = 0; idx < series.length; idx++) {
                newItems.push({ val: series[idx], side, img: 1 });
                newItems.push({ val: series[idx], side, img: 0 });
            }
        } else {
            for (let idx = 0; idx < numItems; idx++) {
                newItems.push({ val: idx, side });
                newItems.push({ val: idx, side });
            }
        }

        const shuffledItems = shuffle(newItems);
        const date = new Date();

        setState({
            items: shuffledItems,
            opened: null,
            flipped: 0,
            remaining: numItems,
            time: date.getTime(),
            sound: null,
        });
    }, [numItems, series, showBack, type]);

    // Simulación de UNSAFE_componentWillReceiveProps
    useEffect(() => {
        const { numItems: prevNumItems, series: prevSeries } = prevPropsRef.current;
        const completed = state.remaining === 0;

        if (
            (numItems !== prevNumItems || (series && series.join() !== prevSeries.join())) &&
            !completed
        ) {
            const items = state.items.map(item => ({ ...item, side: 'back' }));
            setState(prev => ({ ...prev, items }));
        }

        // Actualizar referencias
        prevPropsRef.current = { numItems, series, showBack, type };
    }, [numItems, series, showBack, type, state.remaining, state.items]);

    const clickHandle = (idx, item) => {
        if (item.side === 'back') {
            const { items, flipped, opened } = state;
            const prevOpened = opened !== null ? items[opened] : null;
            const eqs = prevOpened ? prevOpened.val === item.val : false;

            if (flipped < 2) {
                const newItems = [...items];
                newItems[idx] = { ...item, side: 'front' };

                setState(prev => ({
                    ...prev,
                    items: newItems,
                    opened: idx,
                    flipped: flipped + 1,
                    sound: './static/sounds/woosh.mp3',
                }));

                if (flipped === 1) {
                    if (!eqs) {
                        setState(prev => ({ ...prev, sound: './static/sounds/spin_jump.mp3' }));
                        setTimeout(() => {
                            const updatedItems = [...newItems];
                            updatedItems[idx] = { ...updatedItems[idx], side: 'back' };
                            updatedItems[opened] = { ...updatedItems[opened], side: 'back' };
                            setState(prev => ({
                                ...prev,
                                items: updatedItems,
                                opened: null,
                                flipped: 0,
                                sound: null,
                            }));
                        }, 500);
                    } else {
                        const newRemaining = state.remaining - 1;
                        setState(prev => ({ ...prev, sound: './static/sounds/clink.mp3' }));
                        setTimeout(() => {
                            if (newRemaining === 0) {
                                const date = new Date();
                                onComplete(date.getTime() - state.time);
                            } else {
                                setState(prev => ({
                                    ...prev,
                                    items: newItems,
                                    opened: null,
                                    flipped: 0,
                                    remaining: newRemaining,
                                    sound: null,
                                }));
                            }
                        }, 800);
                    }
                }
            }
        }
    };

    const { items, sound, remaining } = state;
    const completedStyle = remaining === 0 ? 'completed' : '';

    return (
        <div className={`couple-list ${completedStyle}`}>
            {sound && <audio src={sound} autoPlay loop={false} />}

            {items.map((item, idx) => {
                const val = item.val;
                let digits = val.toString().split('');
                const isImg = item.img != null ? item.img : 1;
                let imgs = [];

                if (type === 'abacus') {
                    if (isImg) {
                        digits.forEach(digit => {
                            imgs.push(`./static/snapshots/a${digit}.png`);
                        });
                    } else {
                        imgs.push(val);
                    }
                } else {
                    for (let i = 0; i < beads.length && i < items.length / 2; i++) {
                        imgs.push(`./static/beads/${beads[val]}`);
                    }
                }

                const back = <img src="./static/beads/back.jpg" alt="bead" />;
                return (
                    <div key={idx} onClick={() => clickHandle(idx, item)}>
                        {item.side === 'back'
                            ? back
                            : imgs.map((imgSrc, idy) =>
                                isImg ? (
                                    <img className="bead" src={imgSrc} alt="bead" key={idy} />
                                ) : (
                                    <span key={idy}>{imgSrc}</span>
                                )
                            )}
                    </div>
                );
            })}
        </div>
    );
};

export default Couples;